export default __webpack_public_path__ + "static/media/guard.dad3d33f.jpg";